// Hack option select so it generates bootstrap style html

// insert new multi-selectors and hide original selector
Shopify.OptionSelectors.prototype.replaceSelector = function(domId) {
  var oldSelector = document.getElementById(domId);
  var last = oldSelector.parentNode.parentNode;
  var parent = last.parentNode;
  Shopify.each(this.buildSelectors(), function(el) {
    parent.insertBefore(el, last);
  });
  oldSelector.style.display = 'none';
  last.style.display = 'none';
  this.variantIdField = oldSelector;
};

// buildSelectors(index)
// create and return new selector element for given option
Shopify.OptionSelectors.prototype.buildSelectors = function() {
  // build selectors
  for (var i = 0; i < this.product.optionNames().length; i++) {
    var sel = new Shopify.SingleOptionSelector(this, i, this.product.optionNames()[i], this.product.optionValues(i));
    sel.element.disabled = false;
    this.selectors.push(sel);
  }

  // replace existing selector with new selectors, new hidden input field, new hidden messageElement
  var optionNames = this.product.optionNames();
  var elements = Shopify.map(this.selectors, function(selector) {
    var clearfix = document.createElement('div');
    clearfix.setAttribute('class', "clearfix");
    var div = document.createElement('div');
    div.setAttribute('class', "input");
    // create label if more than 1 option (ie: more than one drop down)
    if (optionNames.length > 1) {
      // create and appened a label into div
      var label = document.createElement('label');
      label.htmlFor = selector.element.id;
      label.innerHTML = selector.name;
      clearfix.appendChild(label);
    } 
    div.appendChild(selector.element);
    clearfix.appendChild(div);
    return clearfix;
  });

  return elements;
};


jQuery(document).ready(function($) {
  // links to # shouldn't go anywhere
  $('body').on('click', 'a[href$=#]', function (e) { e.preventDefault() });

  $('#product-gallery').slides({
    preload: true,
    preloadImage: '{{ "icon-loading.gif" | asset_url }}',
    effect: 'slide',
    crossfade: true,
    slideSpeed: 350,
    fadeSpeed: 500,
    generateNextPrev: false,
    generatePagination: false
  });

  // Make all the footer content items the same height
  var footer_content_height = 0;
  var footer_content_items = $('.footer-content .well');
  footer_content_items.each(function(index, item){
    var h = $(item).height();
    if(h > footer_content_height ){
      footer_content_height = h;
    }
  }); 
  footer_content_items.height(footer_content_height);

});


